import React, {Component} from 'react';
import WarehousesList from "../../components/WarehousesList/WarehousesList";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {deleteWarehouse, getWarehouses} from "../../store/actions/warehouse";
import PropTypes from "prop-types";
import Modal from "react-modal";
import Alert from "../../components/popups/Alert";

class Warehouses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      selectedWarehouseId: null
    };
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    if (this.props.auth.user.role === 'general') {
      this.props.history.push('/404');
    }
  }

  componentDidMount() {
    this.props.getWarehouses();
  }

  deleteWarehouse(id) {
    this.openModal(id);
  }

  closeModal(action, confirmed = false) {
    if (confirmed) {
      this.props.deleteWarehouse(this.state.selectedWarehouseId);
    }

    this.setState({
      modalIsOpen: false,
      selectedWarehouseId: null
    });
  }

  openModal(warehouseId) {
    this.setState({
      modalIsOpen: true,
      selectedWarehouseId: warehouseId
    });
  }

  render() {
    return (
        <main>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-content-center">
                    <h2>List of warehouses</h2>
                    <Link to="/add-warehouse" className="btn btn-primary btn-lg" data-target="" data-toggle="modal">Add
                      warehouse
                    </Link>
                  </div>
                  <div className="card-body overflow-x">
                    <WarehousesList warehouses={this.props.warehouses}
                                    deleteWarehouse={this.deleteWarehouse.bind(this)}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal}>
            <Alert closeModal={this.closeModal}/>
          </Modal>
        </main>
    );
  }
}

Warehouses.propTypes = {
  getWarehouses: PropTypes.func.isRequired,
  warehouses: PropTypes.array.isRequired,
  deleteWarehouse: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  warehouses: state.warehouse.warehouses,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  getWarehouses: () => dispatch(getWarehouses()),
  deleteWarehouse: id => dispatch(deleteWarehouse(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Warehouses);



// WEBPACK FOOTER //
// ./src/containers/Warehouses/Warehouses.jsx